import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-input-radio',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.sass'],
})
export class InputRadioComponent {
  @Input() control!: AbstractControl;
  @Input() error = '';
  @Input() title = '';
  @Input() name = '';
  @Input() id!: string;
  @Input() variants: { title: string; value: string; id: string }[] = [];
}
